/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiClientDetails
 */
export interface ApiClientDetails {
    /**
     * 
     * @type {string}
     * @memberof ApiClientDetails
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof ApiClientDetails
     */
    clientSecret?: string;
    /**
     * True when the credentials still issue access tokens that are valid for longer than a day.
     * @type {boolean}
     * @memberof ApiClientDetails
     */
    longLivedAccessTokens?: boolean;
    /**
     * When the credentials were created.
     * @type {Date}
     * @memberof ApiClientDetails
     */
    createdTime?: Date;
}

/**
 * Check if a given object implements the ApiClientDetails interface.
 */
export function instanceOfApiClientDetails(value: object): value is ApiClientDetails {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function ApiClientDetailsFromJSON(json: any): ApiClientDetails {
    return ApiClientDetailsFromJSONTyped(json, false);
}

export function ApiClientDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiClientDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'clientSecret': json['clientSecret'] == null ? undefined : json['clientSecret'],
        'longLivedAccessTokens': json['longLivedAccessTokens'] == null ? undefined : json['longLivedAccessTokens'],
        'createdTime': json['createdTime'] == null ? undefined : (new Date(json['createdTime'])),
    };
}

export function ApiClientDetailsToJSON(json: any): ApiClientDetails {
    return ApiClientDetailsToJSONTyped(json, false);
}

export function ApiClientDetailsToJSONTyped(value?: ApiClientDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'clientSecret': value['clientSecret'],
        'longLivedAccessTokens': value['longLivedAccessTokens'],
        'createdTime': value['createdTime'] == null ? value['createdTime'] : value['createdTime'].toISOString(),
    };
}

